import {AddVoteButton as Add} from "./AddVoteButton";
import {RemoveVoteButton as Remove} from "./RemoveVoteButton";

export const VoteButtons = {
  Add,
  Remove,
};
